import type { UpdateWages } from '@web/onboarding/Checklist/onboardingChecklist.types';
import type { RestangularPosition } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import WagesForPositionsContent from '@web/onboarding/Checklist/DefineWagesModal/WagesForPositionsContent';
import usePositionWages from '@web/onboarding/Checklist/DefineWagesModal/hooks/usePositionWages';

type Props = {
  positions: RestangularPosition[];
  updateWages: UpdateWages;
  onCancel: () => void;
  afterSubmitCallback?: () => void;
};

const WagesForPositionsContentWithData = ({
  positions,
  updateWages,
  afterSubmitCallback,
  onCancel,
}: Props) => {
  const { fields, submitWages } = usePositionWages({
    positions,
    updateWages,
    afterSubmitCallback,
  });

  return <WagesForPositionsContent fields={fields} submitWages={submitWages} onCancel={onCancel} />;
};

export default WagesForPositionsContentWithData;
